export default __webpack_public_path__ + "5cf197c8342d183045a45f401690da49.png";